/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_Stat_ExercisesInputs */

const en_us2_workout_after_stat_exercises = /** @type {(inputs: Workout_After_Stat_ExercisesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercises`)
};

const pt_br2_workout_after_stat_exercises = /** @type {(inputs: Workout_After_Stat_ExercisesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercícios`)
};

const es_419_workout_after_stat_exercises = /** @type {(inputs: Workout_After_Stat_ExercisesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ejercicios`)
};

const pt_pt2_workout_after_stat_exercises = /** @type {(inputs: Workout_After_Stat_ExercisesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercícios`)
};

const fr_fr2_workout_after_stat_exercises = /** @type {(inputs: Workout_After_Stat_ExercisesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercices`)
};

const de_de2_workout_after_stat_exercises = /** @type {(inputs: Workout_After_Stat_ExercisesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übungen`)
};

const it_it2_workout_after_stat_exercises = /** @type {(inputs: Workout_After_Stat_ExercisesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esercizi`)
};

/**
* | output |
* | --- |
* | "Exercises" |
*
* @param {Workout_After_Stat_ExercisesInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_stat_exercises = /** @type {((inputs?: Workout_After_Stat_ExercisesInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Stat_ExercisesInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_stat_exercises(inputs)
	if (locale === "es-419") return es_419_workout_after_stat_exercises(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_stat_exercises(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_stat_exercises(inputs)
	if (locale === "de-DE") return de_de2_workout_after_stat_exercises(inputs)
	if (locale === "it-IT") return it_it2_workout_after_stat_exercises(inputs)
	return en_us2_workout_after_stat_exercises(inputs)
});
export { workout_after_stat_exercises as "workout-after.stat_exercises" }